<template>
  <ViewSources></ViewSources>
</template>
<script>
import ViewSources from "@/components/IAReputation/Views/Sources.vue"

export default {
  components: {ViewSources},
}
</script>
